import type { ConditionsByLetterResult } from 'lib/queries/conditions';
import React from 'react';
import { Paragraph, Wrap } from '@leafwell/components';
import ConditionsList from './conditions-list';
import Pagination from './pagination';
import AlphabetList from './alphabet-list';
import { useWordPressContext } from 'contexts/wordpress-provider';

export default function ConditionsByLetter({
  letter,
  conditions,
  pagination,
  activeCondition,
  variant = 'default',
}: ConditionsByLetterResult & {
  activeCondition?: string;
  variant?: 'default' | 'minimal';
}) {
  const isMinimal = variant === 'minimal';
  const { translations } = useWordPressContext();

  return (
    <Wrap className="!gap-y-6">
      <Paragraph size={isMinimal ? 'small' : 'large'}>
        {translations['Explore A-Z conditions']}
      </Paragraph>
      {!isMinimal && (
        <Paragraph size="small" className="-mt-4">
          {
            translations[
              'Find your condition and click on it to learn all about the most current research and patient stories.'
            ]
          }
        </Paragraph>
      )}
      <AlphabetList initialLetter={letter} bgColor="gray-100" />
      <ConditionsList
        conditions={conditions}
        variant={variant}
        activeCondition={activeCondition}
      />
      {!isMinimal && conditions?.length ? (
        <Pagination
          limit={pagination.limit}
          offset={pagination.offset}
          total={pagination.total}
          className={'col-span-full'}
        />
      ) : null}
    </Wrap>
  );
}
